module.exports = __webpack_public_path__ + "numerical_sorting_21.svg";